import { yearCalendarClasses } from "@mui/x-date-pickers";

export const DELETE = 1;
export const ACTIVE = 0;
const Status = {
  DELETE: DELETE,
  ACTIVE: ACTIVE,
};
export type DiaryStatus = (typeof Status)[keyof typeof Status];

export type Dirary = {
  id: number; //日報ID
  workerId: string; //社員番号
  workerName: string; //社員名
  departmentId: number; //部署ID
  affiliationFactoryId: number; //所属工場ID
  jobId: number; //役職コード
  workingDate: string; //作業開始日
  factoryId: number; //製作工場
  constructionId: number; //工事区分
  startTime: string; //作業開始時間
  endTime: string; //作業終了時間
  isBreak: boolean; //30分休憩
  breakTime: number; //休憩時間（分）
  totalWorkingTimeByHour: number; //合計作業時間(時間)
  totalWorkingTimeByMinute: number; //合計作業時間(分)
  productNo: string; //製作番号1
  productBno: string; //製作番号2
  siteName: string; //現場名
  slipNumber: string; //伝票番号
  processName: string; //工程名
  processId: string; //工程ID
  estimatedTime: number; //予定工数
  workingTimeByHour: number; //作業時間(時間)
  workingTimeByMinute: number; //作業時間(分)
  comment: string; //コメント
  isSendable: boolean; //送信可能
  isDisabled: boolean; //無効
  status: DiaryStatus; //ステータス
}; //24項目

export type processInfo = {
  id: number;
  processId: string;
  processName: string;
  productNo: string;
  productBno: string;
  slipNumber: string;
  estimatedTime: number;
  achievementsTimeByHour: number;
  achievementsTimeByMinute: number;
  laborClassification: number;
};

export type Calendar = {
  date: string;
  shortDate: string;
  isHoliday: boolean;
};

//社員、製作番号、現場、工事区分別集計
export type summaryByWorker = {
  workerId: string;
  workerName: string;
  constructionId: number;
  constructionName: string;
  productNo: string;
  productBno: string;
  siteName: string;
  totalWorkingTimeByMinute: number;
  totalEstimatedTime: number;
  totalWorkingTimeByHour: number;
  totalWorkingTimeText: string;
  factoryId: number;
  factoryName: string;
  achivementByProcess: Array<processInfo>;
};
//製作番号、現場、工事区分別集計
export type summaryByProductNo = {
  constructionId: number;
  productNo: string;
  productBno: string;
  siteName: string;
  constructionName: string;
  totalWorkingTimeByMinute: number;
  totalWorkingTimeByHour: number;
  totalWorkingTimeText: string;
  totalEstimatedTime: number;
  numberOfWorkers: number;
  factoryId: number;
  factoryName: string;
  achivementByProcess: Array<processInfo>;
};

//社員情報
export type WorkerForMatrix = {
  id: string;
  name: string;
};
